import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appLicensePlate]',
})
export class LicensePlateDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(event: any): void {
    let value = event.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');

    if (value.length > 7) {
      value = value.substring(0, 7);
    }

    if (value.length > 3) {
      value = value.substring(0, 3) + '-' + value.substring(3);
    }

    this.el.nativeElement.value = value;
  }
}
